export const fullEncodeURIComponent = (val: string | number | boolean) =>
  encodeURIComponent(val).replace(/\(/g, '%28').replace(/\)/g, '%29')
